import { render, staticRenderFns } from "./rcc-dialog.vue?vue&type=template&id=437d6bbd&"
import script from "./rcc-dialog.vue?vue&type=script&lang=js&"
export * from "./rcc-dialog.vue?vue&type=script&lang=js&"
import style0 from "./rcc-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports